/* A type-guard to identify if an entity has a description */
export var entityHasDescription = function (value) {
  return value && value.hasOwnProperty && value.hasOwnProperty('description');
};
// type guards
export var isEntityWithCountry = function (value) {
  return value !== null && value.hasOwnProperty('country');
};
export var isEntityWithTaxonomies = function (value) {
  return (value === null || value === void 0 ? void 0 : value.hasOwnProperty('challenges')) || (value === null || value === void 0 ? void 0 : value.hasOwnProperty('keyIssues')) || (value === null || value === void 0 ? void 0 : value.hasOwnProperty('trends')) || (value === null || value === void 0 ? void 0 : value.hasOwnProperty('topics')) || (value === null || value === void 0 ? void 0 : value.hasOwnProperty('subTopics')) || (value === null || value === void 0 ? void 0 : value.hasOwnProperty('sdgs'));
};
export var isEntityWithChallenges = function (value) {
  return value === null || value === void 0 ? void 0 : value.hasOwnProperty('challenges');
};
export var isEntityWithKeyIssues = function (value) {
  return value === null || value === void 0 ? void 0 : value.hasOwnProperty('keyIssues');
};
export var isEntityWithTrends = function (value) {
  return value === null || value === void 0 ? void 0 : value.hasOwnProperty('trends');
};
export var isEntityWithTopics = function (value) {
  return value === null || value === void 0 ? void 0 : value.hasOwnProperty('topics');
};
export var isEntityWithSubTopics = function (value) {
  return value === null || value === void 0 ? void 0 : value.hasOwnProperty('subTopics');
};
export var isEntityWithSdgs = function (value) {
  return value === null || value === void 0 ? void 0 : value.hasOwnProperty('sdgs');
};
// type guards
export var isEntityWithLocation = function (value) {
  return value !== null && value.hasOwnProperty('location');
};
// type guards
export var isEntityWithEconomy = function (value) {
  return value !== null && value.hasOwnProperty('economy');
};
// type guards
export var isEntityWithCoordinates = function (value) {
  return value !== null && value.hasOwnProperty('latitude') && value.hasOwnProperty('longitude');
};